import axios from 'axios'
import { developer } from './env';

const HOST = process.env.NODE_ENV === 'production' ? `https://${developer}.zkqsxt.com` : ' http://localhost:8080';

console.log(developer, '====123123===')

export function request(method, data, url) {
    let headers = {
        'client-type': 'browser',
        'Content-Type': 'application/json;',
        'Accept': 'application/json',
        'request_header': '00666'
    }
    if (localStorage.getItem('companyId')) {
        headers = {
            'client-type': 'browser',
            'Content-Type': 'application/json;',
            'Accept': 'application/json',
            'request_header': '00666',
            'companyId': localStorage.getItem('companyId')
        }
    }
    return new Promise((resolve, reject) => {
        axios({
            url: HOST + url,
            method: method || 'GET',
            data: data,
            headers: headers
        }).then((res) => {
            console.log(res, "request res")
            resolve(res.data)
        }).catch(err => {
            // console.error('uni.request fail [network]', err)
            reject(err)
        })
    })
}

export function get(url, data) {
    return request('GET', data, url)
}

export function post(url, data, id = '') {
    return request('POST', data, url, id)
}

export function put(url, data) {
    return request('PUT', data, url)
}

export function del(url, data) {
    return request('DELETE', data, url)
}